import React, { useEffect, useState } from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard'; 
import firebase from './../../../firebase';
import { Button,  Col, OverlayTrigger, Tooltip, Form, Row , InputGroup} from 'react-bootstrap'; 
import Select from 'react-select';
import {typehome} from 'config' 
import DatePicker , {registerLocale, setDefaultLocale} from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import {useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; 
import fr from 'date-fns/locale/fr';
import logoAirbnb from 'assets/img/logos/airbnb_logo.png';
import logoexpedia from 'assets/img/logos/expedia.png';
import logoabritel from 'assets/img/logos/abritel.png';
import logodirect from 'assets/img/logoIcon.png';
import tripadvisor from 'assets/img/logos/tripadvisor.jpg';
import locasun from 'assets/img/logos/locasun.png';
import homeToGo from 'assets/img/logos/homeToGo.jpeg'
import kayak from 'assets/img/logos/kayak.webp'
import homerez from 'assets/img/logos/homerez.png'
import booking from 'assets/img/logos/booking.png'
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { useFormatDate } from 'hooks'; 
import moment from 'moment';

const OutilRapport = () => {

    registerLocale('fr', fr);
    setDefaultLocale('fr');
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false);
    const [checkIn, setCheckIn] = React.useState(null);
    const [checkOut, setCheckOut] = React.useState(null);
    const [valueType, setValueType] = React.useState(null);
    const [properties, setProperties] = React.useState([]);
    const [bookings, setBookings] = React.useState([]);
    const [data, setData] = React.useState([])
    const [typehomem, setTypH] = React.useState([])
    const [searchs, setSearchs] = React.useState([]);
    const [users, setUsers] = React.useState([]);
    const [isadmin, setAdmin] = React.useState(false)
    const [propertiesCheck, setPropertiesCheck] = React.useState([])
    const [clients, setClients] = React.useState([]);
    const getUserL = async (uid,s,  cb) => { 
        let d = null;
        s.forEach(u=> {
            if (u.value === uid){
                d =  u.data
                d.id = u.value
            }
        })
        cb(d)
      };
   
      const logo = (l) => {
     
        switch (l?.value) {
          case "booking":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={booking}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger>  
          case "homerez":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={homerez}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger>  
          case "kayak":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={kayak}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger>  
          case "homeToGo":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={homeToGo}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger>  
          case "locasun":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={locasun}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger> 
          case "tripadvisor":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={tripadvisor}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger> 
          case "direct":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={logodirect}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger> 
          case "abritel":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={logoabritel}
                  alt={l}
                  width={50}  
                />
          </OverlayTrigger> 
          case "airbnb":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
                  src={logoAirbnb}
                  alt={l}
                  width={30}  
                />
          </OverlayTrigger> 
          case "expedia":
            return <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                {l.label}
              </Tooltip>
            }
          >
             <img
            src={logoexpedia}
            alt={l}
            width={30}  
          />
          </OverlayTrigger> 
        
          default:
            return <span>{l?.label}</span>;
        }
      }
    
    
    const getSearchs = () => {
        firebase.firestore().collection('searchs') 
        .orderBy('_create_At', 'desc')
        .get().then((ls)=> {
        let s = [];
        ls.forEach((d) => { 
            let e = d.data()
            e.id = d.id; 
            if (e?.delete === true){
    
            }else{
                s.push(e)
            }
        })
        // console.log("search", s);
        setSearchs(s);  
    
    }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
    })
    
    }
 
  function levenshteinDistance(str1, str2) {
        const len1 = str1.length;
        const len2 = str2.length;
    
        const matrix = [];
    
        // Initialize the distance matrix
        for (let i = 0; i <= len1; i++) {
            matrix[i] = [i];
        }
        for (let j = 0; j <= len2; j++) {
            matrix[0][j] = j;
        }
    
        // Calculate the distances
        for (let j = 1; j <= len2; j++) {
            for (let i = 1; i <= len1; i++) {
                if (str1.charAt(i - 1) === str2.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1,  // substitution
                        matrix[i][j - 1] + 1,      // insertion
                        matrix[i - 1][j] + 1       // deletion
                    );
                }
            }
        }
    
        // Return the Levenshtein distance
        return matrix[len1][len2];
    }

    function textsAreSimilar(text1, text2, threshold) {
        const distance = levenshteinDistance(text1, text2);
        const maxLength = Math.max(text1.length, text2.length);
        const similarityPercentage = ((maxLength - distance) / maxLength) * 100;
    
        return similarityPercentage >= threshold;
    }
 

function estDansLaPlage(dateDebut, dateFin, plageDebut, plageFin) {
    return dateDebut >= plageDebut && dateFin <= plageFin;
}

function filtrerBooking(f, p) {
    const {adultNbr,checkin, checkout, destinate, kidsNbr, priceMax, priceMin, roomsNbr, roomsNbrMax, type } = f
     return bookings.filter((book) => {
        let b = true
        // console.log('book', book);
        if (checkin && checkout){
            if (book.statut?.value === 'confirmed'){  
                if (!estDansLaPlage(book.checkin.toDate(), book.checkout.toDate(), checkin, checkout)) {
                    b  = false;
                } 
            } else{
                b  = false;
            }
        }
        if (adultNbr || kidsNbr){
             let tt = Number(book?.adultNbr || 0) + Number(book?.kidsNbr || 0)
            if (!((Number(adultNbr || 0) + Number(kidsNbr || 0)) <= Number(tt))){
                b  = false;
            }
        } 
        if (roomsNbr){//min  
            if (!(Number(roomsNbr) <= Number(book?.roomsNbr)) ){
                b =  false;
            }
        }
        if (roomsNbrMax){//max  
            if (!(Number(roomsNbrMax) >= Number(book?.roomsNbr)) ){
                b =  false;
            }
        }
        if (priceMin){ 
            if (!(Number(priceMin) <= Number(book?.total_pay)) ){
                b =  false;
            }
        }
        if (priceMax){ 
            if (!(Number(priceMax) >= Number(book?.total_pay)) ){
                b =  false;
            }
        }
        if (type){ 
            let ok = false;
            p?.forEach((mp)=> {
                if (mp.id === book.property.value){
                    if (mp.type.value === type.value){
                        ok =  true;
                    }
                }
            })
            if (!ok){
                b = false
            }
        }

        if (destinate?.length > 0){ 
            const threshold = 80; 
            let propriete = null;
            p?.forEach((mp)=> {
                if (mp.id === book.property.value){
                    propriete = mp;
                }
            })
            if (!textsAreSimilar(destinate, propriete?.nameHouse, threshold)) {
                b = false;
            }
            if (!textsAreSimilar(destinate, propriete?.zipcode, threshold)) { 
                b = false;
            }
            if (!textsAreSimilar(destinate, propriete?.quartier, threshold)) {  
                b = false;
            }
            if (!textsAreSimilar(destinate, propriete?.city, threshold)) {  
                b = false;
            } 
        } 
        return b;
    });

}



  const searc = (p) => {
    // console.log('recherche en cours...', p)
    // let proper = p;

    let infosearch = {...formd};
    // console.log('search', infosearch)
    let sser = filtrerBooking(infosearch, p);
    // console.log("sser", sser)
    setData(sser)
    setPropertiesCheck(sser);
    if (sser.length === 0){
        toast.error('Aucun résultat')
    } 

  }

  const loadList = (cb) => {
    // get list clients and format
    firebase.firestore().collection('properties').get().then((snap)=> {
        let s = [];
        snap.forEach((d) => {  
            const dr = d.data()
            dr.id = d.id;
            if (dr?.delete){

            }else{
                s.push(dr)
            }
        })
        setProperties(s);  
        cb(s)
    }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
    })

    firebase.firestore().collection('crm').get().then((snapq)=> {
        let s = [];
        snapq.forEach((d) => { 
            let e = '';
            let pre = d.data()?.email?.split(',') || []
            pre.forEach((s) =>{
                e += `${s}, `;
            })
          const dr = {value : d.id, label: `${d.data()?.lastName} ${d.data()?.firstName}`, data: d.data() }
          if (d.data()?.delete){}
          else{
            s.push(dr)
          }
        })
        setClients(s); 
        firebase.firestore().collection('bookings').get().then((snap)=> {
            let sq = [];
            snap.forEach((d) => {  
                const dr = d.data()
                dr.id = d.id;
                if (dr?.delete){
    
                }else{
                    s?.forEach((c) => {
                        if (c.value === dr.client?.value){ 
                            dr.villa = dr.property.label
                            dr.cl = c.data;
                        }
                    })
                    sq.push(dr)
                } 
            })
            setBookings(sq);   

        }).catch((error) => {
            setL(false); 
            var errorMessage = error.message;
            toast.error(errorMessage);
        })
      }).catch((error) => {
        setL(false); 
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
    
    
 
}

useEffect(() => {
    setL(true)
    getSearchs()
    getAllUser()
    
    let m = [{label: 'Tout', value:null}];
    typehome.forEach(s => {
        m.push(s)
    })
    setTypH(m)
    loadList((n) => {
        setL(false)
    })
}, [])


  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
        return;
    } 
    if ((properties || [])?.length  > 0){
        loadList(p => {
            searc(p)
        }); 
    }else{
        searc(properties)
    }
    
     
};


  const handleChange = e => { 
    let d = {... formd};
    // console.log(e.target, e.target.checked);  
    d[e.target.name] = e.target.value;
    if (e.target.name === "type"){
        d[e.target.name] =  e.target.checked ? "partenaire" : "admin" ;
    }
    setFrom(d); 
  };

 
 

 

  const getAllUser = async () => { 
    await firebase.firestore()
      .collection("users") 
      .get().then((snap)=> {
        let s = [];
        snap.forEach((d) => {
          var l = d.data(); 
          if (l?.delete){
            // supprimer donc ne pas affiché
          }else{ 
              const dr = {value : d.id, label: `${l?.lastName} ${l?.firstName}`, data: l}
              s.push(dr) 
          }
          setUsers(s);

          getUserL(firebase.auth().currentUser.uid, s, (user) => { 
            // console.log("user", user); 
            if (user && user?.type === 'admin'){
              setAdmin(true); 
            }
          });
        })
    })
      .catch((error) => {
        console.log("error", error); 
      });
  };


  const columns = [
    {
      accessor: 'origin',
      Header: 'Origine',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
        <div style={{display: "flex",
          alignItems: "center",
          justifyContent: "center"}}>
          {logo(row.original?.origin)} 
        </div>
      )
    },  
    {
      accessor: 'villa',
      Header: 'Villa',
      headerProps: { className: 'text-900' }, 
      Cell: ({ row }) => (
      <>
        <span>{row.original.villa}</span> 
        <br/>
        {row?.original?.checkin && row?.original?.checkin?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
            {useFormatDate(row.original?.checkin?.toDate(), {
                day:'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short', 
            })}
            </small> 
        )}
        <br/>
        {row?.original?.checkout && row?.original?.checkout?.toDate !== undefined && (
            <small className="has-text-grey is-abbr-like">
                {useFormatDate(row.original?.checkout?.toDate(), {
                day:'numeric',
                weekday: 'short',
                year: 'numeric',
                month: 'short', 
                })}
            </small> 
        )}
     </>
      )
    },       
   
    {
      accessor: 'client',
      Header: 'Client',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { cl, client } = rowData.row.original
        return <p>
            Client: {cl.lastName} {cl.firstName}<br/>
            Langue: {cl.nationality}<br/>
            Tel: {cl.phone}<br/>
            Email: {client?.email}<br/>
            Préférences: {cl?.preferences?.join(', ') || "Aucun"}
        </p>
      }
    },   
    {
        accessor: 'comment',
        Header: 'Commentaire',
        headerProps: { className: 'text-900' }, 
      },
      {
          accessor: 'total_pay',
          Header: 'Total',
          headerProps: { className: 'text-900' },
          Cell: rowData => {
            const { total_pay } = rowData.row.original
            return <span>{total_pay} €</span>
          }
        },       
  ];

   


 


  function AdvanceTableExample() {

    if (l){
      return <p>Chargement...</p>
    }
    return (
      <AdvanceTableWrapper
        columns={columns}
        data={data}
        sortable
        pagination
        perPage={205}
      > 
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
        <div id="orders-actions"> 
  
        <Col xs="auto" sm={6} lg={4}>
            <AdvanceTableSearchBox table/>
          </Col>
      </div>
        </Col>
        <AdvanceTable
          table
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        />
        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={data.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    );
  } 

  return (
    <>
        <FalconComponentCard>
            <FalconComponentCard.Header title="Outil de rapport" light={false} noPreview={true}  />
            <FalconComponentCard.Body >
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Form.Group as={Col} md="4" controlId="destinate">
                    <Form.Label>Destination (Nom, zipcode, quartier, ville, ..)</Form.Label>
                    <Form.Control
                    onChange={handleChange} 
                        name="destinate" 
                        type="text"
                        placeholder="Destination" 
                    />
                    <Form.Control.Feedback type="invalid">
                        Veuillez indiquez votre Destination.
                    </Form.Control.Feedback>
                    <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="checkin">
                    <Form.Label>Arrivée</Form.Label>
                    <DatePicker 
                        dateFormat="dd/MM/yyyy"
                        selected={checkIn} 
                        minDate={new Date()}
                        startDate={checkIn}
                        endDate={checkOut}  
                        selectsStart
                        onChange={newDate => {  
                            let d = formd;
                            d['checkin'] = newDate;
                            setFrom(d)
                            setCheckIn(newDate) 
                        }}
                        customInput={
                            <CustomDateInput
                            formControlProps={{
                                placeholder: 'jj/mm/yyyy',
                            //     ...register(`ScheduleStartDate${index}`)
                            }}
                            />
                        }
                        /> 
                    </Form.Group>
                    
                    <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                        <Form.Label>Départ</Form.Label>

                        <DatePicker
                        selected={checkOut} 
                        minDate={checkIn}
                        selectsEnd 
                        startDate={checkIn}
                        endDate={checkOut}
                        dateFormat="dd/MM/yyyy"
                        onChange={newDate => {
                            let d = formd;
                            d['checkout'] = newDate;
                            setFrom(d)
                            setCheckOut(newDate) 
                        }}
                        customInput={
                            <CustomDateInput
                            formControlProps={{
                                placeholder: 'jj/mm/yyyy',
                            //     ...register(`ScheduleStartDate${index}`)
                            }}
                            />
                        }
                        />
                    </Form.Group> 
                </Row>
                <Row className="mb-3">
                    <p>
                        Voyageurs
                    </p>
                    <Form.Group as={Col} md="3" controlId="adultNbr">
                    <Form.Label>Nombre total d'adulte</Form.Label>
                    <Form.Control   
                        type="number"
                        name="adultNbr"
                        onChange={handleChange}
                        placeholder="Nombre total d'adulte" 
                        min={1}
                    /> 
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="kidsNbr">
                        <Form.Label>Nombre total d'enfant</Form.Label>
                        <Form.Control  
                            type="number"
                            name="kidsNbr"
                            onChange={handleChange}
                            placeholder="Nombre total d'enfant" 
                            min={0}
                        /> 
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="roomsNbr">
                        <Form.Label>Nombre min de chambre(s)</Form.Label>
                        <Form.Control  
                            type="number"
                            name="roomsNbr"
                            value={formd.roomsNbr}
                            onChange={handleChange}
                            placeholder="Nombre total de chambre" 
                            min={0}
                        /> 
                    </Form.Group>

                    <Form.Group as={Col} md="3" controlId="roomsNbr">
                        <Form.Label>Nombre max de chambre(s)</Form.Label>
                        <Form.Control  
                            type="number"
                            name="roomsNbrMax"
                            value={formd.roomsNbrMax}
                            onChange={handleChange}
                            placeholder="Nombre max de chambre" 
                            min={0}
                        /> 
                    </Form.Group>
                </Row>
                <Row className="mb-3">


                <Form.Group as={Col} md="3" controlId="type">
                    <Form.Label>Type de bien</Form.Label>
                    <Select
                            closeMenuOnSelect={false} 
                            options={ typehomem}
                            placeholder='Choisir...' 
                            classNamePrefix="react-select"
                            value={valueType}
                            onChange={value => {
                                setValueType(value) 
                                let d = formd;
                                d['type'] = value;
                                setFrom(d);
                            
                            }}
                            />
                    </Form.Group>

                    <Form.Group as={Col} md="3" controlId="priceMin">
                        <Form.Label>Budget Minimum (sans symbole €)</Form.Label>
                        <Form.Control
                            onChange={handleChange} 
                            name="priceMin" 
                            type="text"
                            placeholder="Prix minimum € " 
                        />
                    </Form.Group>

                    <Form.Group as={Col} md="3" controlId="priceMax">
                        <Form.Label>Budget Maximum (sans symbole €)</Form.Label>
                        <Form.Control
                            onChange={handleChange} 
                            name="priceMax" 
                            type="text"
                            placeholder="Prix maximum €" 
                        />
                    </Form.Group>
                </Row> 
                <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Rechercher'}</Button>
                </Form>
            </FalconComponentCard.Body>
        </FalconComponentCard>
         {data.length > 0 && (
            <>
            
            <div style={{display:'flex', justifyContent:'space-between', flexDirection:'row'}}>
            <p>Résultats ({data.length})</p>
             
            </div>  
             <FalconComponentCard>
        <FalconComponentCard.Body>
            <AdvanceTableExample />
        </FalconComponentCard.Body>
        </FalconComponentCard>
            </>
         )}     

          
    </>
  );  
  };

export default OutilRapport;
